import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Drukwerkproducten bestellen',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Productdetails',
    [ProductOrderingSteps.ShippingInfo]: 'Verzendinfo',
    payment: 'Betaling',
  },
  form: {
    title: 'Bestelgegevens',
    polygraphy_product_id: {
      label: 'Product',
      placeholder: 'Product selecteren',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Flyer - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Sjabloon #1 🆕',
            [FlyerTemplate.Two]: 'Sjabloon #2 🆕',
            [FlyerTemplate.Three]: 'Sjabloon #3',
            [FlyerTemplate.Four]: 'Sjabloon #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Sticker - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Sjabloon #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Deursticker - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Sjabloon #1 🆕',
            [DoorStickerTemplate.Two]: 'Sjabloon #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Aantal',
      placeholder: 'Aantal invoeren',
    },
    service_level: {
      label: 'Serviceniveau',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Saver',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standaard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Bedrijf',
      placeholder: 'Bedrijfsnaam invoeren',
    },
    shipping_salutation: {
      label: 'Aanhef',
      options: {
        mr: 'Dhr.',
        mrs: 'Mevrouw',
      },
    },
    shipping_first_name: {
      label: 'Voornaam',
      placeholder: 'Voornaam invoeren',
    },
    shipping_last_name: {
      label: 'Achternaam',
      placeholder: 'Achternaam invoeren',
    },
    shipping_country: {
      label: 'Land',
      placeholder: 'Land selecteren',
    },
    shipping_state: {
      label: 'Staat',
      placeholder: 'Staat selecteren',
    },
    shipping_city: {
      label: 'Stad',
      placeholder: 'Stad invoeren',
    },
    shipping_address: {
      label: 'Adres',
      placeholder: 'Adres invoeren',
    },
    shipping_zip_code: {
      label: 'Postcode',
      placeholder: 'Postcode invoeren',
    },
    shipping_phone_number: {
      label: 'Telefoonnummer',
      placeholder: 'Telefoonnummer invoeren',
    },
    create_invoice: {
      options: {
        true: 'Automatisch factureren - Direct afgeschreven',
        false: 'Gratis verzenden - Dit is een cadeau',
      },
    },
  },
  table: {
    title: 'Eerdere bestellingen',
    fields: {
      product: 'Product',
      quantity: 'Aantal',
      status: 'Status',
      service_level: 'Serviceniveau',
      shipping: 'Verzending',
      tracking_url: 'Tracking-url',
      created: 'Aangemaakt',
      updated: 'Laatste update',
    },
  },
  labels: {
    shipping_company: 'Bedrijf',
    shipping_salutation: 'Aanhef',
    shipping_first_name: 'Voornaam',
    shipping_last_name: 'Achternaam',
    shipping_address: 'Adres',
    shipping_zip_code: 'Postcode',
    shipping_city: 'Stad',
    shipping_phone_number: 'Telefoonnummer',
    show_shipping_details: 'Verzendgegevens',
    track_order: 'Bestelling volgen',
    pending_from_provider: 'Wachtend op leverancier',
  },
  modals: {
    confirmation: {
      title: 'Bestelgegevens bevestigen',
    },
    free_order_confirmation: {
      title: 'Weet u zeker dat u {{product}} gratis wilt verzenden?',
      description:
        'U heeft gekozen uw klant vandaag niet te factureren.\n Het product wordt zonder betaling verzonden.',
      buttons: {
        confirm: 'Ja, gratis verzenden',
      },
    },
  },
  buttons: {
    back_to_templates: 'Terug naar sjablonen',
    preview: 'Voorbeeld',
    next: 'Volgende',
    order: 'Bestelling aanmaken',
    confirm: 'Bevestigen',
  },
  feedback: {
    shop_url_used: 'Product bevat Online shop URL (<url>{{url}}</url>). Is dit de bedoeling?',
    order_total_price: 'Totaalprijs voor de geselecteerde producten: <strong>{{amount}} NET</strong>',
  },
  toasts: {
    failed_to_create_order: 'Bestelling aanmaken mislukt',
    order_got_created: 'Bestelling aangemaakt',
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
